import { render, staticRenderFns } from "./editFive.vue?vue&type=template&id=22d1f6a6&"
import script from "./editFive.vue?vue&type=script&lang=js&"
export * from "./editFive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports